import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import SupplierContactDiv from './SupplierContactDiv'
import SupplierMainCustomerDiv from './SupplierMainCustomerDiv'
import SupplierYearTurnoverDiv from './SupplierYearTurnoverDiv'
import SupplierMainInstrumentDiv from './SupplierMainInstrumentDiv'
import SendEmailFormDiv from './SendEmailFormDiv'
import { exportFile } from '../../public/index'

import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate } from '../../public/utility'
import { concat } from 'lodash'


class SupplierDiv extends React.Component {
	state = {
		search: this.props.search || false,
		auditShow: this.props.auditShow != undefined ? this.props.auditShow : true,
		roles: this.props.roles || []
	}

	SettingsDiv = {
		联系人: SupplierContactDiv,
		主要客户: SupplierMainCustomerDiv,
		年营业额: SupplierYearTurnoverDiv,
		主要设备: SupplierMainInstrumentDiv
	}

	componentDidMount = () => {
		this.doGetSupplier(this.props.id, '')
	}

	doGetSupplier = (id, fieldsets) => {
		const { taskName } = this.props
		Tyan.doPostEvent({
			event: 'GetSupplier',
			data: { id, taskName },
			onEnd: ({ errorMessage, bReadOnly, initValues基本信息, initValues联系人, initValues主要客户, initValues年营业额, initValues主要设备, initValues采购记录, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				this.setState({
					...{ id, optionsParas, bReadOnly, initValues联系人, initValues主要客户, initValues年营业额, initValues主要设备, initValues采购记录 },
					...(fieldsets ? {} : { initValues基本信息, changedValues基本信息: {} })
				})
			}
		})
	}

	handlerSave = () => {
		const { id, changedValues基本信息, } = this.state
		Tyan.doPostEvent({
			event: 'SaveSupplier',
			data: { id, changedValues基本信息 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				Ext.toast('保存成功')
				this.doGetSupplier(id, '')
			}
		})
	}

	handlerDelete = () => {
		const { onClose, onSave } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteSupplier',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
						return
					}
					Ext.toast('删除成功')
					onClose && onClose()
					onSave && onSave()
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	canSave = () => {
		return getFormValue(this, '基本信息', '供应商名称') && getFormValue(this, '基本信息', '供应商编号')
			&& getFormValue(this, '基本信息', '公司地址') && getFormValue(this, '基本信息', '公司负责人')
			&& getFormValue(this, '基本信息', '税分类') && getFormValue(this, '基本信息', '发票种类')
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	handleShowDiv = (name, title, id, SupplierID, bDelete) => {
		const { bReadOnly } = this.state
		const { readOnly } = this.props
		const Comp = this.SettingsDiv[name]
		Tyan.pubForm.showDialog(title, props => <Comp {...props} id={id} SupplierID={SupplierID} type={title} bDelete={bDelete}
			bReadOnly={bReadOnly} readOnly={readOnly} onSave={() => this.doGetSupplier(SupplierID, name)} />)
	}

	handlerSendEmailForm = (emailTemplet) => {
		const { onClose } = this.props
		const { id: SupplierID, initValues基本信息 } = this.state
		const { 状态名称 } = initValues基本信息
		Tyan.pubForm.showDialog('邮件信息', props => <SendEmailFormDiv {...props} emailTemplet={emailTemplet} SupplierID={SupplierID} onSave={() => 状态名称 == '申请中' && onClose && onClose()} />)
	}

	handlerPushData = () => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'SupplierPushData',
			data: { id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				Ext.toast('推送成功')
			}
		})
	}

	handlerSupplierExport = () => {
		const { id } = this.state
		exportFile(null, null, "SupplierExport?id=" + id)
	}

	fieldset供应商信息 = () => {
		const { roles } = this.state
		// const roles = Tyan.loginInfo.roles
		console.log('roles', roles)
		return [
			{ _text: '供应商编号', minWidth: '45%', required: true, disabled: true },
			{ _text: '供应商名称', minWidth: '45%', required: true },
			{ _text: '统一社会信用代码', minWidth: '45%' },
			// { _float: '成交总额', minWidth: '45%' },
			{ _text: '公司地址', minWidth: '45%', required: true },
			{ _text: '公司法定代表人', name: '公司负责人', minWidth: '45%', required: true },
			{ _text: '公司电话', minWidth: '45%' },
			{ _date: '公司成立日期', minWidth: '45%' },
			{ _text: '注册资本金', minWidth: '45%' },
			{
				_group: '', minWidth: '45%', margin: 0, items: [
					{ _int: '员工人数', minWidth: '45%' },
					{ _int: '其中技术人员', name: '技术人员', minWidth: '45%', },
				]
			},
			{ _radio: '公司类型', minWidth: '45%' },
			{ _select: '付款条件', name: '付款方式', minWidth: '45%' },
			{ _text: '银行开户名称', minWidth: '45%' },
			{ _text: '银行帐号', minWidth: '45%' },
			{ _text: '开户银行', minWidth: '45%' },
			{ _select: '采购经办人', minWidth: '45%' },
			{ _text: '银行地址', minWidth: '45%' },
			{ _select: '发票税率', minWidth: '45%' },
			{ _select: '发票种类', minWidth: '45%', required: true },
			{ _select: '经营类别', minWidth: '45%' },
			{ _select: '税分类', minWidth: '45%', required: true },
			{ _select: '会计分类', minWidth: '45%' },
			{ _checkbox: '公司资质', minWidth: '95%' },
			{ _radio: '信息安全保密制度', minWidth: '45%', },
			{ _radio: '近三年客户信息泄露事件', minWidth: '45%' },
			{ _select: '交易币别', minWidth: '45%' },
			{ _text: 'Switf code', name: 'SwitfCode', minWidth: '45%' },
			{ _select: '分类', minWidth: '45%' },
			{ _select: '采购项目', minWidth: '45%', multiSelect: true, },
			{ _text: '经营范围', minWidth: '95%', maxRows: 3 },
			{ _text: '关联公司及关系', minWidth: '95%', maxRows: 3 },
			{ _text: '主要产品/服务项目及其营业额', name: '主要产品服务项目及其营业额', minWidth: '95%', maxRows: 3 },
			{ _text: '曾用名', minWidth: '95%', maxRows: 3 },
			{ _files: '附件', minWidth: '95%', disabled: !(roles.indexOf('采购人') > -1) },
		]
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset联系人 = () => {
		const { readOnly } = this.props
		const { id: SupplierID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '联系人', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '姓名', minWidth: 150, },
					{ _text: '联系电话', minWidth: 150, },
					{ _text: '邮箱', minWidth: 150, flex: 1, },
				],
				buttons: [
					{ _button: '添加联系人...', icon: 'plus', handler: () => this.handleShowDiv('联系人', '联系人', 0, SupplierID, true), cdt: () => !bReadOnly && !readOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('联系人', '联系人', data.id, SupplierID, true) },
			}]
	}

	fieldset主要客户 = () => {
		const { readOnly } = this.props
		const { id: SupplierID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '主要客户', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '公司名称', minWidth: 150, flex: 1, align: 'left' },
					{ _text: '年度', minWidth: 150, flex: 1, },
					{ _text: '年营业额', minWidth: 150, flex: 1, },
				],
				buttons: [
					{ _button: '添加主要客户...', icon: 'plus', handler: () => this.handleShowDiv('主要客户', '主要客户', 0, SupplierID, true), cdt: () => !bReadOnly && !readOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('主要客户', '主要客户', data.id, SupplierID, true) },
			}]
	}

	fieldset年营业额 = () => {
		const { readOnly } = this.props
		const { id: SupplierID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '年营业额', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '年份', minWidth: 150, },
					{ _text: '营业额', minWidth: 150, flex: 1, },
				],
				buttons: [
					{ _button: '添加年营业额...', icon: 'plus', handler: () => this.handleShowDiv('年营业额', '年营业额', 0, SupplierID, true), cdt: () => !bReadOnly && !readOnly },
				],
				onDoubleTap: data => { this.handleShowDiv('年营业额', '年营业额', data.id, SupplierID, data.bDelete) },
			}]
	}

	fieldset主要设备 = () => {
		const { readOnly } = this.props
		const { id: SupplierID, bReadOnly } = this.state
		return [
			{
				_grid: '', name: '主要设备', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '名称', minWidth: 150, flex: 1, },
					{ _text: '品牌型号', minWidth: 150, flex: 1, },
					{ _text: '购买时间', minWidth: 150, flex: 1, },
					{ _text: '制造商', minWidth: 150, flex: 1, },
					{ _text: '数量', minWidth: 150, flex: 1, },
					{ _text: '使用工序', minWidth: 150, flex: 1, },
					{ _text: '产能', minWidth: 150, flex: 1, align: 'left' },
				],
				buttons: [
					{ _button: '添加...', icon: 'plus', handler: () => this.handleShowDiv('主要设备', '主要生产/检测设备', 0, SupplierID, true), cdt: () => !bReadOnly && !readOnly }
				],
				onDoubleTap: data => { this.handleShowDiv('主要设备', '主要生产/检测设备', data.id, SupplierID, data.bDelete) },
			}]
	}

	fieldset采购记录 = () => {
		const { initValues基本信息 } = this.state
		const { 成交总额 } = initValues基本信息
		return [
			{
				_grid: '', name: '采购记录', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '名称', minWidth: 150, flex: 1, },
					{ _text: '品牌型号', minWidth: 150, flex: 1, },
					{ _date: '购买时间', minWidth: 150, flex: 1, },
					{ _text: '制造商', minWidth: 150, flex: 1, },
					{ _text: '数量', minWidth: 150, flex: 1, align: 'left' },
				],
				buttons: [
				],
			},
			{
				_group: '', minWidth: '95%', layout: { type: 'vbox', pack: 'end', align: 'right' }, items: [
					{ _label: `成交总额：${成交总额}`, minWidth: '50', flex: 1, margin: '0' },
				]
			}
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly, } = this.props
		const { errorMessage, initValues基本信息, id, bReadOnly, search, auditShow, roles } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		if (errorMessage) return <Message text={errorMessage} />
		const { 状态, 状态名称, 二级部门 } = initValues基本信息
		const canSave = this.canSave()
		const bChanged = this.bChanged()
		// console.log('auditShow', this.props.auditShow)
		// console.log('auditShow', auditShow)
		// console.log('状态名称', 状态名称)
		// console.log('bReadOnly', bReadOnly) 
		// console.log('readOnly', readOnly)
		return <Body data={this} maxWidth="1100"
			controls={
				(bReadOnly || readOnly) ?
					[
						{ _flow: 'SupplierFlow', disabled: this.bChanged(), cdt: () => id > 0 && !search, },
						{ _button: '推至鼎捷', icon: 'save', handler: () => this.handlerPushData(), cdt: () => (id > 0 && 二级部门 == '宜特检测') && !search && auditShow, disabled: bChanged },
						{ _button: '发送资料表', icon: 'save', handler: () => this.handlerSendEmailForm('发送资料表'), cdt: () => 状态名称 == '已完成' && auditShow, disabled: bChanged },
						{ _button: '保存', icon: 'save', handler: this.handlerSave, cdt: () => roles.indexOf('采购人') > -1 && bChanged },
						{ _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					] : [
						{ _button: '推至鼎捷', icon: 'save', handler: () => this.handlerPushData(), cdt: () => (id > 0 && 二级部门 == '宜特检测') && !search, disabled: bChanged },
						{ _button: '发送资料表', icon: 'save', handler: () => this.handlerSendEmailForm('发送资料表'), cdt: () => 状态名称 == '核对中', disabled: bChanged },
						{ _button: '发送供应商信息表', icon: 'save', handler: () => this.handlerSendEmailForm('发送供应商信息表'), cdt: () => id > 0 && 状态 == 1, disabled: bChanged },
						{ _flow: 'SupplierFlow', disabled: this.bChanged(), cdt: () => id > 0 && !search, },
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
						{ _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					id > 0 && {
						_fieldsets: [
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
							{ title: '联系人', _fieldset: this.fieldset联系人(), fullblock: true },
							{ title: '主要客户', _fieldset: this.fieldset主要客户(), fullblock: true },
							{ title: '年营业额', _fieldset: this.fieldset年营业额(), fullblock: true },
							{ title: '主要生产/检测设备', name: '主要设备', _fieldset: this.fieldset主要设备(), fullblock: true },
							{ title: '采购记录', _fieldset: this.fieldset采购记录(), fullblock: true },
						], height: '40%', docked: 'bottom', margin: '0 5 0 5',
					},
					{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset供应商信息(), disabled: bReadOnly || readOnly },
				]}
		/>
	}
}

export default connect()(SupplierDiv)